var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSend(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.9 20.3999L21.35 12.9199C21.5304 12.8431 21.6842 12.7149 21.7923 12.5513C21.9004 12.3877 21.9581 12.196 21.9581 11.9999C21.9581 11.8038 21.9004 11.6121 21.7923 11.4485C21.6842 11.2849 21.5304 11.1567 21.35 11.0799L3.9 3.5999C3.7489 3.534 3.58377 3.50675 3.41951 3.52061C3.25525 3.53447 3.09702 3.589 2.9591 3.6793C2.82118 3.76959 2.70791 3.8928 2.6295 4.0378C2.5511 4.18281 2.51003 4.34506 2.51 4.5099L2.5 9.1199C2.5 9.6199 2.87 10.0499 3.37 10.1099L17.5 11.9999L3.37 13.8799C2.87 13.9499 2.5 14.3799 2.5 14.8799L2.51 19.4899C2.51 20.1999 3.24 20.6899 3.9 20.3999Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSend);
export default __webpack_public_path__ + "static/media/send.d831f09460b8ce8b6f33b04745b10ce7.svg";
export { ForwardRef as ReactComponent };